import createReducer from 'shared/utils/createReducer';
import requestsStatuses from 'modules/common/constants/requestsStatuses';
import { LOGOUT } from 'modules/auth/actions/logout';
import { SEND_OTP_CODE } from 'modules/auth/actions/sendOtpCode';
import { EXTERNAL_LOGIN } from 'modules/auth/actions/externalLogin';

const defaultState = {
  requestStatus: requestsStatuses.default,
  value: undefined,
};

export default createReducer(defaultState, {
  [SEND_OTP_CODE.failure]: () => ({
    ...defaultState,
    requestStatus: requestsStatuses.failure,
  }),

  [SEND_OTP_CODE.pending]: (state) => ({
    ...state,
    requestStatus: requestsStatuses.pending,
  }),

  [SEND_OTP_CODE.success]: (state, { payload: { refreshToken } }) => ({
    ...state,
    requestStatus: requestsStatuses.success,
    value: refreshToken,
  }),

  [EXTERNAL_LOGIN.success]: (state, { payload: { refreshToken } }) => ({
    ...state,
    requestStatus: requestsStatuses.success,
    value: refreshToken,
  }),

  [LOGOUT.failure]: () => defaultState,
  [LOGOUT.success]: () => defaultState,
});
